import { Suspense } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { useSSR } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './legacyfrontend/i18n';
import './styles/index.css';
import storeClient from './storeClient';

// Extend HTMLElement for React root container
interface ExtendedHTMLElement extends HTMLElement {
  _reactRootContainer?: Root;
}

const BaseApp = (): JSX.Element => {
  useSSR(window.initialI18nStore, window.initialLanguage);

  return (
    <Suspense fallback={<div />}>
      <Provider store={storeClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Suspense>
  );
};

const container = document.getElementById('root') as ExtendedHTMLElement;
let root: Root = container._reactRootContainer;
if (!root) {
  root = createRoot(container);
  container._reactRootContainer = root;
}
root.render(<BaseApp />);

if (module.hot) {
  module.hot.accept();
} 